<template>
    <MenuDropDown
        :items="regions"
        :label="regionCode"
        class="menu-drop-down"
        @select="goToRegion(regions[$event]?.value.code)"
    />
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import {
    getRoutingRegion,
    useRegionPlugin,
    useRegionSelectOptions,
} from '@/plugins/region'
import type { RegionCode } from '@/graphql/api'

import MenuDropDown from '@/components/ui/menus/MenuDropDown.vue'

const router = useRouter()
const { selectAndPersistRegion, regionCode } = useRegionPlugin()

const regions = useRegionSelectOptions()

const goToRegion = (region: RegionCode | undefined) => {
    if (!region) {
        return
    }

    selectAndPersistRegion(region).then(() =>
        router.push({
            ...router.currentRoute.value,
            // @ts-expect-error alabala
            params: {
                ...router.currentRoute.value.params,
                region: getRoutingRegion(region),
            },
        })
    )
}
</script>

<style lang="scss" scoped>
.menu-drop-down {
    text-transform: uppercase;

    @include min-width(1024) {
        background: $stone-2;
    }

    :deep(.menu-button) {
        @include min-width(1024) {
            color: $slate;
        }
    }

    :deep(.menu) {
        right: 0;
        left: auto;

        @include min-width(1024) {
            background: $stone-2;
        }

        .item {
            @include min-width(1024) {
                color: $slate;
            }

            &:focus {
                @include min-width(1024) {
                    color: rgba($slate, 0.7);
                }
            }

            @include min-width(1024) {
                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }
}
</style>
